import { createWatchStore, setProperty, updateWatchStore } from 'src/js/store/use-watch';
import { mapNmosViewModel, NmosServiceResponse, NmosViewModel } from './nmos-models';
import { apiClientWithoutHandler } from 'src/js/api';
import { APIPath } from 'src/js/api/route-path-index';
import { notificationHandler } from 'src/js/notification/notification-handler';
import { TFunction } from 'i18next';
import { GenericResponse } from 'src/js/model/api/response/generic-response';
import { createAndDispatchNotification } from 'src/js/notification/notification-helper';
import { NotificationVariant } from 'src/js/notification/notification';

// values will be inited from API at runtime
const nmosService: NmosViewModel = {
  nodePort: 0,
  mode: 'automatic',
};

createWatchStore(nmosService);

const setNmosServiceProperty = (key: string, value: any) => {
  setProperty(nmosService, key as keyof typeof nmosService, value);
};
export { setNmosServiceProperty };
export const saveResponseToNmosService = (response: NmosViewModel) => {
  updateWatchStore(nmosService, response);
};

export const updateNmos = (model: NmosViewModel, t: TFunction) => {
  const path = APIPath.services.nmos;
  return apiClientWithoutHandler.genericController
    .put<NmosServiceResponse>(path, mapNmosViewModel(model))
    .then((res) => {
      notificationHandler(res, t('settings.services.nmos.successMsg'), t('settings.services.nmos.errorMsg'), t);
      const response = (res as any)?.data?.data;
      if (response) {
        // formRef.current.setFieldValue('hostname', response.emsHostname, true);
        // formRef.current.setFieldValue('port', response.emsPort, true);
        // formRef.current.setFieldValue('keepAlive', response.emsKeepalive, true);
      }
      return res;
    })
    .finally(() => {
      ////
    });
};

export const validateNmosAddress = (ip: string, t: TFunction): Promise<any> => {
  return apiClientWithoutHandler.genericController
    .post<GenericResponse>(APIPath.hostnamevalidate.nmos, { hostname: ip })
    .then((res) => {
      if (res.ok) {
        const response = res.data;
        if (!response.success) {
          createAndDispatchNotification(
            t('settings.services.nmos.notifications.invalidIpAddressErrorMsg'),
            NotificationVariant.ERROR,
            t,
          );
        }
      }
      return res;
    });
};

export default nmosService;
